<script setup lang="ts">
/**
 * ScholarTrip 2.0 - Packages Landing
 * 1. Professional Omnisearch (Active: Packages)
 * 2. GEO/AEO FAQ injection for general audience
 * 3. Mobile-optimized Hero: No junk text, pure function.
 */

import FlightsOmnisearchPanel from "~/components/home/HeroSearch.vue";

useSeoMeta({
  title: "Exclusive Student & General Travel Bundles | ScholarTrip",
  description:
    "Combine official airline fares with global hotel partners. Save up to 25% with our AI-synced travel packages.",
});
// AEO: 針對 Generative Search 注入 FAQ 數據
useHead({
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "How much can I save with ScholarTrip bundles?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "By combining live official airline inventory with our partner hotels, travelers save an average of $214 per trip compared to separate bookings.",
            },
          },
        ],
      }),
    },
  ],
});
definePageMeta({ transparentHeader: true });
</script>
<template>
  <div class="bg-slate-50 min-h-screen">
    <!-- 1. Hero Section: Saturated functionality for Mobile -->
    <section
      class="relative min-h-[75vh] flex flex-col items-center justify-center pt-24 pb-12 overflow-hidden bg-slate-900"
    >
      <div class="absolute inset-0 z-0">
        <NuxtImg
          src="https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?q=80&w=2074&auto=format&fit=crop"
          class="w-full h-full object-cover opacity-35"
          format="webp"
          priority
        />
        <div
          class="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-transparent to-slate-50"
        ></div>
      </div>
      <div class="relative z-10 w-full max-w-7xl mx-auto px-4 text-center">
        <h1
          class="text-4xl md:text-7xl font-black text-white mb-4 tracking-tighter leading-tight animate-fade-in-up uppercase italic"
        >
          Travel <span class="text-brand-400">Bundles</span>
        </h1>
        <p
          class="text-base md:text-xl text-slate-200 font-medium max-w-2xl mx-auto mb-10 opacity-90 leading-relaxed"
        >
          Official Airline Inventory + Curated Hotel Stays.
          <br class="hidden sm:block" />
          Seamlessly synced for the ultimate journey.
        </p>
        <!-- 核心搜尋面板：預設啟動 Package 產品線 (Core Omnisearch for Packages) -->
        <div class="max-w-6xl mx-auto w-full">
          <FlightsOmnisearchPanel active="packages" />
        </div>
      </div>
    </section>
    <!-- 2. Trending Bundles Section -->
    <div class="max-w-7xl mx-auto px-6 lg:px-8 -mt-12 relative z-20 pb-32">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-8">
        <div class="md:col-span-12">
          <HomeTrendingDestinations />
        </div>
      </div>
    </div>
  </div>
</template>
